import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default _ref => {
  let {
    components,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(MDXTag, {
    name: "wrapper",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "h2",
    components: components
  }, `在你开始之前...`), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, `Ant Design 的 issue 列表只接受 Bug 报告或是新功能请求 (Feature Request)。这意味着`, /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "p"
  }, `我们不接受用法问题（How to 类问题）`), `。如果你开的 issue 不符合规定，它将会被`, /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "p"
  }, `立刻关闭`), `。`, /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "p",
    props: {
      "href": "#intro-modal"
    }
  }, `为什么要这么严格？`)), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, `对于使用中遇到的问题，请使用以下资源：`), /*#__PURE__*/React.createElement(MDXTag, {
    name: "ul",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, `仔细阅读 `, /*#__PURE__*/React.createElement("a", {
    href: "https://ant.design/docs/react/introduce-cn",
    target: "_blank"
  }, `使用文档`), ` 和 `, /*#__PURE__*/React.createElement("a", {
    href: "https://ant.design/components/overview-cn",
    target: "_blank"
  }, `组件文档`), `。`), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, `提问前确保你在 `, /*#__PURE__*/React.createElement("a", {
    href: "https://ant.design/docs/react/faq-cn",
    target: "_blank"
  }, `常见问题`), ` 和 `, /*#__PURE__*/React.createElement("a", {
    href: "https://ant.design/changelog-cn",
    target: "_blank"
  }, `更新日志`), ` 中搜索过`), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, `在 `, /*#__PURE__*/React.createElement("a", {
    href: "https://stackoverflow.com/questions/ask?tags=antd",
    target: "_blank"
  }, `StackOverflow`), ` (英文) 或是 `, /*#__PURE__*/React.createElement("a", {
    href: "https://segmentfault.com/t/antd",
    target: "_blank"
  }, `SegmentFault`), `（中文）搜索和提问`)), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, `最后，在开 issue 前，可以先搜索一下以往的旧 issue - 你遇到的问题可能已经有人提了，也可能已经在最新版本中被修正。注意：如果你发现一个已经关闭的旧 issue 在最新版本中仍然存在，请不要在旧 issue 下面留言，而应该用下面的表单开一个新的 issue。`));
};